import { ComponentState } from "../../../shared/types/ComponentState";
import { AccountInfoBanner } from "./AccountInfoBanner";
import { CodeAndDescription } from "../shared/CodeAndDescription";
import { ContributionReason } from "./ContributionReason";
import { EAuthModel } from "./EAuthModel";
import { IraFields } from "./IraFields";
import { MessageFields } from "./MessageFields";
import { PositionsFields } from "./PositionsFields";
import { RecurringFields } from "./RecurringFields";
import { ToAccountInfo } from "./ToAccountInfo";
import { TrustFields } from "./TrustFields";
import { InternalTransferPositionsResponse } from "./InternalTransferPositionsResponse";
import { TableColumn } from "../../../shared/types/TableColumn";
import { AuthResponse } from "../shared/AuthResponse";
import { Revalidation } from "../shared/Revalidation";

export class InternalTransferInfo {
  processDate: string;
  stateCd: string;
  isRMDEligible: boolean;
  rmdAnnualRemainingAmount: string;
  hasPositionsAccess: boolean;
  hasPositions: boolean;
  positionsValidIraContributionCode: string;
  acknowledgementArtifactContent: string;
  iraContributionTypeMap: ContributionReason[];
  toAccountInfo: ToAccountInfo;
  iraFields: IraFields;
  isLoaOnFile: boolean;
  recurringFields: RecurringFields;
  trustFields: TrustFields;
  accountInfoBanner: AccountInfoBanner;
  warningsList: string[];
  errorText: string;
  taxCodeList: {};
  isTrustNonPTRSAccount: boolean;
  pjlsEnabled: boolean;
  isIdentical: boolean;
  hasWpfaRole: boolean;
  hasMoveMoneyDataAccess: boolean;
  serviceError: string;
  eauthAccess: boolean;
  clientAuthorizationNeeded: boolean;
  isExpandReportingJournal: boolean;
  isRMDToDisplay: boolean;
  isThirdParty: boolean;
  eAuthModel: EAuthModel;
  canViewJournalWithPositions: boolean;
  accountRegistration: string[];
  journalCashAmount: string;
  totalCashAmount: string;
  totalWithdrawalAmount: string;
  iraContributionType: ContributionReason;
  pendReasons: string[];
  attentionLabelStatus: boolean;
  isPendingOnlyForCTWE: boolean;
  isPendingForLPND: boolean;
  messageInfo: MessageFields;
  loginId: string;
  source: CodeAndDescription;
  trustTaxCode: string;
  positionsInfo: PositionsFields;
  nickname: string;
  hasError: boolean;
  taxId: string;
  caseId: string;
  submitAndCreateSloaId: string;
  status: CodeAndDescription;
  requestedDate: string;
  requestedTime: string;
  cashieringReqId: number;
  cashieringReqSecondaryId: number;
  isPendingForCTWE: boolean;
  eAuthTransactionScoreCardLogMessage: string;
  eAuthSloaScoreCardLogMessage: string;
  inputCallFinished: boolean;
  inputCallSuccessful: boolean;
  positionLotCallFinished: boolean;
  verifyCallFinished: boolean;
  acknowledgeCallFinished: boolean;
  toAccountState: ComponentState;
  inputIraFields: IraFields;
  positionsLotDetails: InternalTransferPositionsResponse;
  rowData: TableColumn[];
  loadToAccountErrorText: string;
  verifyErrorText: string;
  standingAuthCallSucceeded: boolean;
  shouldShowStateTax: boolean;
  netCashAmount: string;
  isSubmitAndCreate: boolean;
  txnCode: string;
  cashieringIraAgreementText: string;
  journalAuthResponse: AuthResponse;
  revalidationStatus?: string;
  revalidation?: Revalidation;
}
